module.exports = __webpack_public_path__ + "static/media/elo_black.6b2b2d07.png";